import React from "react";
import "../styles/Services.css";

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Conceptual, Preliminary & Detailed Design",
      description: "Description of service 1 and its benefits to customers.",
      image: "/images/services/design.jpg",
    },
    {
      id: 2,
      title: "FE Strength Analysis & Structural Optimization",
      description: "Description of service 2 and its benefits to customers.",
      image: "/images/services/structural-optimisation.jpg",
    },
    {
      id: 3,
      title: "CFD Analysis & Thermal Efficiency Improvement",
      description: "Description of service 3 and its benefits to customers.",
      image: "/images/services/thermal.jpg",
    },
    {
      id: 4,
      title: "Vibration, Acoustics & Durability Analysis",
      description: "Description of service 4 and its benefits to customers.",
      image: "/images/services/acoustic.jpg",
    },
    {
      id: 5,
      title: "Electromagnetics & Electro-Magnetics System Analysis",
      description: "Description of service 5 and its benefits to customers.",
      image: "/images/services/electromag.jpg",
    },
    {
      id: 6,
      title: "SI, PI, EMI & EMC Analysis",
      description: "Description of service 6 and its benefits to customers.",
      image: "/images/services/analysis.jpg",
    },
    {
      id: 7,
      title: "Composites & Advance Materials",
      description: "Description of service 6 and its benefits to customers.",
      image: "/images/services/composite.jpg",
    },
    {
      id: 8,
      title: "Proto-build & Manufacturing",
      description: "Description of service 6 and its benefits to customers.",
      image: "/images/services/manufacturing.jpg",
    },
  ];

  return (
    <div className="page-content">
      <h2>Our Services</h2>
      <div className="services-heading">
        We at Infinipoint offer end-to-end Engineering Services & Solutions in
        Electro-Mechanical System Design, Structural, Thermal, Chemical,
        Electromagnetic, CFD and System Analysis domain along with Manufacturing
        solutions to varied industry verticals like Aerospace & Defense,
        Automotive, Heavy Engineering, Manufacturing, Oil & Gas, Energy & Power,
        Medical Devices & Hi-Tech Electronics, Telecommunication and
        Architecture, Engineering & Construction (AEC) industries etc. across
        the globe.
      </div>
      <section className="services-section">
        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <img src={service.image} alt={service.title} />
              <h3>{service.title}</h3>
              {/* <p>{service.description}</p> */}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Services;
